import React from "react";
import { Provider } from "react-redux";
import { theme } from "./utils/theme";
import { ThemeProvider } from "@mui/material/styles";
import store from "./store/index";
import { BrowserRouter } from "react-router-dom";
import RootView from "./router/Router";
import { Box } from "@mui/material";
import { SidebarProvider } from "./context/SidebarContext";

const appStyle = {
  width: "100%",
  minHeight: "100vh",
  boxSizing: "border-box",
  padding: "0",
  margin: "0",
};

const App = () => {
  return (
    <Box sx={appStyle}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <SidebarProvider>
              <RootView />
            </SidebarProvider>
          </BrowserRouter>
        </ThemeProvider>
      </Provider>
    </Box>
  );
};

export default App;
